import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import { Model, Opts, PagedResponse } from "@ofqual/portal-core/core/types";
import { paramsToSearchString } from "@ofqual/portal-core/core/utils/urlHelper";
import { OfqualRoles } from "../domain/userRole";

export class UserService extends BaseRemoteService {
  public async getAll(opts: Opts): Promise<Model[]> {
    const url = `${this.apiRoot}/users/${paramsToSearchString({
      pageSize: 999,
      userType: 1,
      role: OfqualRoles,
      active: true,
    })}`;
    const response = await super.getRequest<PagedResponse<Model>>(
      url,
      opts
    );
    return response.data;
  }
}